/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import GetQuotesButton from './GetQuotesButton';

/* Load adviser banner images for all sizes */
require('url!../../../../images/adviser_banner_xsmall.jpg');
require('url!../../../../images/adviser_banner_small.jpg');
require('url!../../../../images/adviser_banner_tablet.jpg');
require('url!../../../../images/adviser_banner_medium.jpg');
require('url!../../../../images/adviser_banner_large.jpg');

export default class AdviserInfo extends Component {

    render() {
        return (
            <div className="app__landing-page__section--full">
                <div className="app__landing-page__full-image adviser-banner__image">
                    <div className="app__landing-page__adviser-info--left">
                        <div className="adviser-banner__header">
                            <span className="line">
                                "The adviser was extremely knowledgeable…we felt reassured that we were in good hands."
                            </span>
                        </div>
                        <div className="adviser-banner__subtitle">
                            The independent mortgage advisers we suggest for you will be local to you,
                            verified experts, and positively reviewed by their clients
                        </div>

                        <GetQuotesButton section="Adviser Section" handler={ this.props.scrollToForm } />
                    </div>
                </div>
            </div>
        );
    }
}

AdviserInfo.propTypes = {
    scrollToForm: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/steps/landing/AdviserInfo.jsx